import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';

// ✅ Move this AFTER all imports
if (typeof window !== 'undefined') {
  const originalError = console.error;
  console.error = (...args) => {
    const msg = args[0];
    if (
      typeof msg === 'string' &&
      (msg.includes('ResizeObserver loop completed') ||
       msg.includes('ResizeObserver loop limit exceeded'))
    ) {
      return;
    }
    originalError(...args);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
